import { render, staticRenderFns } from "./files.vue?vue&type=template&id=0f275487&scoped=true"
import script from "./files.vue?vue&type=script&lang=js"
export * from "./files.vue?vue&type=script&lang=js"
import style0 from "./files.vue?vue&type=style&index=0&id=0f275487&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f275487",
  null
  
)

export default component.exports